export const GUIDED_JOURNEY_LABELS = Object.freeze({
  launcher: "Guided journey",
  step: "Step",
  close: "Close",
  skip: "Skip Guide",
  next: "Next",
  finish: "Finish",
  waiting: "Continue",
  targetUnavailable: "This guide step is not available on the current screen.",
  domainMustBeAvailable:
    "Enter a valid domain and complete the availability check before continuing.",
  tourConfirmTitle: "Take a quick tour?",
  tourConfirmDesc: "We'll guide you through each step to get your hub up and running.",
  tourConfirmBtn: "Show me around",
  tourConfirmSkip: "Not now",
  tourConfirmTitleSub: "Take a quick tour?",
  tourConfirmDescSub: "We'll walk you through selecting the right plan and activating your subscription.",
  tourConfirmBtnSub: "Show me around",
  steps: {
    tourConfirm: {
      title: "Take a quick tour?",
      description: "",
    },
    hubDisplayName: {
      title: "Name your hub",
      description:
        "This is the business-group name shown inside ZiniHub. Use a clear name that identifies your organisation.",
    },
    hubDomainName: {
      title: "Choose your hub domain",
      description:
        "Enter the unique domain prefix for your hub. Use lowercase letters, numbers, and hyphens only.",
    },
    hubDomainCheck: {
      title: "Check domain availability",
      description:
        "Check that the domain is available. You must complete this check before ZiniHub can create the hub.",
    },
    hubDomainPreview: {
      title: "Review the domain",
      description:
        "This preview shows the address associated with your hub. Confirm it is correct before continuing.",
    },
    hubSubmit: {
      title: "Complete hub setup",
      description:
        "When the form is valid and the domain is available, select this button to create your hub.",
    },
    subscriptionActivation: {
      title: "Activate your subscription",
      description:
        "Your hub is ready. Activate a trial or select a paid plan before creating a business.",
    },
    subscriptionTrial: {
      title: "Start the free trial",
      description:
        "If a trial is available, use this option to activate the hub immediately.",
    },
    subscriptionPaid: {
      title: "Choose a paid plan",
      description:
        "Select a plan and billing cycle, then continue to payment. Either activation path unlocks business creation.",
    },
    createBusiness: {
      title: "Create your first business",
      description:
        "Your subscription is active. Select Create Business to begin the three-step business setup.",
    },
    draftTab: {
      title: "Your business is saved as a draft",
      description:
        "Continue setting up your business",
    },
    draftBusiness: {
      title: "Continue your draft business",
      description:
        "This is the business you just created. Open Manage Business when you are ready to edit or publish it.",
    },
  },
});
